"use strict";

var _createClass = require("C:\\Projects\\far-fruit\\node_modules\\@babel\\runtime\\helpers\\createClass.js");

var _classCallCheck = require("C:\\Projects\\far-fruit\\node_modules\\@babel\\runtime\\helpers\\classCallCheck.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Point = void 0;

var Point = /*#__PURE__*/_createClass(function Point(position, particle) {
  _classCallCheck(this, Point);

  this.position = position;
  this.particle = particle;
});

exports.Point = Point;